import api from './evvntApi';

export const setupAuthorizationToken = (token = null) => {
  let storedToken = localStorage.getItem('auth_token');
  if (token !== null && storedToken !== token) {
    localStorage.setItem('auth_token', token);
    storedToken = token;
  }
  api.setAuthorizationToken(storedToken);
};

export const clearAuthorizationToken = () => {
  localStorage.removeItem('auth_token');
  api.setAuthorizationToken(null);
};

export const authorizedUrl = (url) => {
  const token = localStorage.getItem('auth_token');
  if (window.location.host.startsWith('new.')) {
    // preserve plugin query params
    const searchParams = window.location.search.replace('?', '#');
    const urlWithToken = url.indexOf('?') == -1 ? `${url}?token=${token}$` : `${url}&token=${token}`;
    return urlWithToken + searchParams;
  } else {
    return url;
  }
};



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/lib/auth.js